import React, { useCallback, useEffect, useState } from "react";
import swapImage from '../assets/images/swap.png';
import '../assets/CSS/style.css'
import linetoprightbox from '../assets/images/sideframe1.svg'
import linebottomrightbox from '../assets/images/sideframe1.svg'
import toast from "react-hot-toast";
import { DWCAddress, USDTAddress, defaultNetwork } from "../config";
import {
  Alldata,
  Approve,
  CheckUser,
  Conversion,
  AnalyticsData,
  Swap,
  SwapRate,
} from "../hooks/useContractData";
import { addToken } from "../hooks/addToken";
import { toLocale } from "../hooks/useContract";
import { useNetwork } from "wagmi";
import coin from "../assets/images/usdt.png"
import coin2 from "../assets/images/defi-world-front.png"


function Swap_page() {
    const [values, setValues] = useState("");
    const [swapt, setswapt] = useState(false);
    const [changeVal, setchangeVal] = useState(true);
    const [dis, setDis] = useState(true);
    const [isSwapped, setIsSwapped] = useState(false);
    const [hidebtn, sethidebtn] = useState(false);

    const { adminFees: addper, perSwapLimit } = AnalyticsData();

    const { sellPrice, buyPrice } = SwapRate();

    const handleChange = (event) => {
        setValues(event.target.value);
    };

    const { chain } = useNetwork()
    const isCorrectNetwork = chain?.id === defaultNetwork;

    const { canSwap } = CheckUser();

    const { execute: doswap } = Swap();
    const { zebBalance, usdtBalance, zebAllowance, usdtAllowance } = Alldata();
    const { execute: getValue, ZebToUsdt, UsdtToZeb, adminFees } = Conversion();
    const { execute: ApproveToken } = Approve(isSwapped ? USDTAddress : DWCAddress);

    const swapAmount = useCallback(async () => {
        try {

            if (!canSwap) return;

            checkAllowanceBeforeSwap();

            if (values > 0) {
                const amount = values;
                setswapt(true);

                const promist = await doswap?.(
                    isSwapped === false ? DWCAddress : USDTAddress,
                    isSwapped === false ? USDTAddress : DWCAddress,
                    String(amount)
                );
                setswapt(false);
            } else {
                toast.error("Please fill the amount")
            }
        } catch (err) {
            setswapt(false);
            toast.error(
                err.reason ? err.reason : err.data ? err.data.message : err.message
            );
        }
    }, [doswap, values, isSwapped, canSwap]);

    const convert = useCallback(
        async (e, token) => {
            try {
                await getValue(token, String(e));
            } catch (err) {
                console.error(err);

                toast.error(
                    err.reason ? err.reason : err.data ? err.data.message : err.message
                );
            }
        },
        [getValue]
    );

    const swap = () => {
        setchangeVal(!changeVal);
        if (isSwapped === true) {

            setValues(UsdtToZeb);
            convert(UsdtToZeb, DWCAddress);
        } else {
            setValues(ZebToUsdt);
            convert(ZebToUsdt, USDTAddress);
        }
        setIsSwapped(!isSwapped);
        setDis(!dis);
    };

  const checkAllowanceBeforeSwap = async () => {

  if (isSwapped === true) {
    // console.log("values if: ", Number(values), Number(usdtAllowance));
    sethidebtn(Number(usdtAllowance) > Number(values));
  } else {
    // console.log("values if: ", Number(values), Number(zebAllowance));
    sethidebtn(Number(zebAllowance) > Number(values));
  }

  };

    useEffect(() => {
        if (isSwapped === true) {
            sethidebtn(Number(usdtAllowance) > Number(values));
        } else {
            sethidebtn(Number(zebAllowance) > Number(values));
        }
    }, [isSwapped, usdtAllowance, zebAllowance]);




    return (
      <section className=" ">
        <div className="container adminReportTable2  ctr mt-15">
          <div className="titlebox text-center mt-52 ">
            <h2 className=" text-4xl md:text-5xl mb-0 md:mb-8 font-semibold anltycs  ">
              <span className="anlytcs">DeFi World</span> Swap
            </h2>
          </div>
        </div>
        <div className="os_container mx-auto py-3   ">
          {/* <div className="titleh2n text-center  anlytcs titlebox blinkers   ">
            <h2 className=' text-4xl md:text-5xl mb-8 font-semibold anltycs  '><span className='anlytcs'>DeFi World</span> Swap</h2>
          </div> */}
          <div className="boxmain p-5  space-y-2 borderboxmain mt-2 mb-0 md:mb-12">
            <img
              className="linetopleft"
              src={linetoprightbox}
              alt="border line"
            />

            <div className={`box ${isSwapped ? "swapChange" : ""}`}>
              <div className="boxinner space-y-4">
                <div className="flex justify-between items-center">
                  <p className="w-1/2">
                    From
                    <br />
                    <button
                      className="addtoken text-cyan-500"
                      onClick={() => {
                        addToken({
                          data: {
                            address: DWCAddress,
                            symbol: "DWC",
                            decimals: 18,
                            name: "DWC",
                            image:
                              "https://swap.defiworld.finance/static/media/defi-world-front.6b929ed46ab6ce344ac2.png",
                          },
                        });
                      }}
                    >
                      Add DWC to Wallet
                    </button>
                  </p>
                  <strong>
                    Balance : <span>{toLocale(zebBalance)}</span>
                  </strong>
                </div>
                <div className="flex items-center space-x-4">
                  <img src={coin2} alt="" width={"25px"} />
                  <div className="leftbx flex items-center space-x-2">
                    <select
                      name="fromCoin"
                      value={"DWC"}
                      defaultValue={"DWC"}
                      className="coin-dropdown"
                      onChange={swap}
                    >
                      <option value={"DWC"}>DWC</option>
                      <option value={"USDT"}>USDT</option>
                    </select>
                  </div>
                  <input
                    type="number"
                    value={changeVal ? values : values * Number(buyPrice)} // UsdtToZeb
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "0",
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                        "7",
                        "8",
                        "9",
                        "Backspace",
                        "ArrowLeft",
                        "ArrowRight",
                        "Delete",
                        ".",
                      ];
                      if (!allowedKeys.includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      handleChange(e);
                      convert(e.target.value, DWCAddress);
                    }}
                    disabled={dis === false ? true : false}
                    placeholder={`Enter Amount`}
                    className="border p-2 flex-1"
                  />
                </div>
              </div>

              <img
                src={swapImage}
                alt="Swap"
                className="mx-auto my-4 cursor-pointer w-12 h-12 invert"
                onClick={swap}
              />

              <div className="boxinner space-y-4">
                <div className="flex justify-between items-center">
                  <p className="w-1/2">
                    To
                    <br />
                    <button
                      className="addtoken text-cyan-500"
                      onClick={() => {
                        addToken({
                          data: {
                            address: USDTAddress,
                            symbol: "USDT",
                            decimals: 6,
                            name: "USDT",
                            image:
                              "data:image/png;base64,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",
                          },
                        });
                      }}
                    >
                      Add USDT to Wallet
                    </button>
                  </p>
                  <strong>
                    Balance : <span>{toLocale(usdtBalance)}</span>
                  </strong>
                </div>
                <div className="flex items-center space-x-4">
                  <img src={coin} alt="" width={"25px"} />
                  <div className="leftbx flex items-center space-x-2">
                    <select
                      name="fromCoin"
                      value={"USDT"}
                      defaultValue={"USDT"}
                      className="coin-dropdown"
                      onChange={swap}
                    >
                      <option value={"DWC"}>DWC</option>
                      <option value={"USDT"}>USDT</option>
                    </select>
                  </div>

                  <input
                    placeholder="Enter amount"
                    type="number"
                    value={changeVal ? values * Number(sellPrice) : values} // ZebToUsdt
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "0",
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                        "7",
                        "8",
                        "9",
                        "Backspace",
                        "ArrowLeft",
                        "ArrowRight",
                        "Delete",
                        ".",
                      ];
                      if (!allowedKeys.includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      handleChange(e);
                      convert(e.target.value, USDTAddress);
                    }}
                    name="numberformat"
                    disabled={dis}
                    className="border p-2 flex-1"
                  />
                </div>
              </div>
            </div>

            <div className="boxinner bxinner space-y-4">
              <div className="flex justify-between items-center py-1">
                <p className="!text-xs">Swap Fees ({addper}%): </p>
                <strong>
                  <span className="text-sm">
                    {/* {Number(adminFees) === 0
                      ? 0
                      : Number(toLocale(adminFees)) === 0
                      ? "less than 0.001"
                      : toLocale(adminFees)} */}

                    {
                    values !== null &&
                      values !== "" &&
                      values !== undefined  ?
                    (parseFloat(values) * parseFloat(addper)) / 100
                    :
                    0
                    }

                    {isSwapped ? " USDT" : " DWC"}
                  </span>
                </strong>
              </div>
              <div className="flex justify-between items-center py-1">
                <p className="!text-xs">Per swap Maxlimit: </p>
                <strong>
                  <span className="text-sm"> {perSwapLimit}</span>
                </strong>
              </div>
            </div>
            <div className="flex ">
              {hidebtn !== true && (
                <button
                  className="buttonGroup btn2 bxinner flex justify-center text-center items-center mt-6  text-white p-2 rounded"
                  onClick={(e) => {
                    if (isCorrectNetwork) {
                      ApproveToken();
                    } else {
                      toast.error("Please connect wallet");
                      e.preventDefault();
                    }
                  }}
                >
                  Approve {isSwapped ? "USDT" : "DWC"}
                </button>
              )}

              <button
                className="buttonGroup btn2 bxinner flex justify-center items-center text-center mt-6 text-white p-2 rounded"
                onClick={(e) => {
                  if (isCorrectNetwork) {
                    if (swapt) {
                      e.preventDefault();
                    } else {
                      swapAmount();
                    }
                  } else {
                    toast.error("Please connect wallet");
                  }
                }}
              >
                {swapt ? "Swaping" : "SWAP"}
              </button>
            </div>

            <img
              className="linebottomright"
              src={linebottomrightbox}
              alt="border line"
            />
          </div>
        </div>
      </section>
    );
}

export default Swap_page;






